import { lazy } from "react";
import { getDsLayoutComponentRenderer, getStandaloneComponentRenderer } from "@kaltura/mediaspace-shared-layout";

const LearningUnit = lazy(() => import("@kaltura/mediaspace-features-moe").then((m) => ({ default: m.LearningUnit })));
const LearningUnits = lazy(() =>
    import("@kaltura/mediaspace-features-moe").then((m) => ({ default: m.LearningUnits }))
);
const ContentComponent = lazy(() =>
    import("@kaltura/mediaspace-features-moe").then((m) => ({ default: m.ContentComponent }))
);
const LearningUnitDone = lazy(() =>
    import("@kaltura/mediaspace-features-moe").then((m) => ({ default: m.LearningUnitDone }))
);
const FacultyDashboard = lazy(() =>
    import("@kaltura/mediaspace-features-moe").then((m) => ({ default: m.FacultyDashboard }))
);
const StudentView = lazy(() => import("@kaltura/mediaspace-features-moe").then((m) => ({ default: m.StudentView })));
const StudentMentoringNotes = lazy(() =>
    import("@kaltura/mediaspace-features-moe").then((m) => ({ default: m.StudentMentoringNotes }))
);
const MentoringNoteQuickAdd = lazy(() =>
    import("@kaltura/mediaspace-features-moe").then((m) => ({ default: m.MentoringNoteQuickAddContainer }))
);
const StudentDashboard = lazy(() =>
    import("@kaltura/mediaspace-features-moe").then((m) => ({ default: m.StudentDashboard }))
);
const GenieHeaderButton = lazy(() =>
    import("@kaltura/mediaspace-features-moe").then((m) => ({ default: m.GenieHeaderButton }))
);
const Personalization = lazy(() =>
    import("@kaltura/mediaspace-features-moe").then((m) => ({ default: m.Personalization }))
);
const PersonalizationPersona = lazy(() =>
    import("@kaltura/mediaspace-features-moe").then((m) => ({ default: m.PersonalizationPersona }))
);
const SessionTracker = lazy(() =>
    import("@kaltura/mediaspace-features-moe").then((m) => ({ default: m.SessionTracker }))
);
const GenieXapiEventsReporter = lazy(() =>
    import("@kaltura/mediaspace-features-moe").then((m) => ({ default: m.GenieXapiEventsReporter }))
);
// the student filter on the feedback admin list (injected through Kms_Type_Component)
const FeedbackStudentFilter = lazy(() =>
    import("@kaltura/mediaspace-features-moe").then((m) => ({ default: m.FeedbackStudentFilter }))
);
const EnglishAssessment = lazy(() =>
    import("@kaltura/mediaspace-features-moe").then((m) => ({ default: m.EnglishAssessment }))
);

const renderLearningUnit = getDsLayoutComponentRenderer(LearningUnit);
const renderLearningUnits = getDsLayoutComponentRenderer(LearningUnits);
const renderContentComponent = getDsLayoutComponentRenderer(ContentComponent);
const renderLearningUnitDone = getDsLayoutComponentRenderer(LearningUnitDone);
const renderFacultyDashboard = getDsLayoutComponentRenderer(FacultyDashboard);
const renderStudentView = getDsLayoutComponentRenderer(StudentView);
const renderStudentMentoringNotes = getDsLayoutComponentRenderer(StudentMentoringNotes);
const renderStudentDashboard = getDsLayoutComponentRenderer(StudentDashboard);
const renderPersonalization = getDsLayoutComponentRenderer(Personalization);
const renderPersonalizationPersona = getDsLayoutComponentRenderer(PersonalizationPersona);
const renderSessionTracker = getStandaloneComponentRenderer(SessionTracker);
const renderEnglishAssessment = getDsLayoutComponentRenderer(EnglishAssessment);

export {
    renderLearningUnit,
    LearningUnits,
    renderLearningUnits,
    LearningUnit,
    renderContentComponent,
    renderLearningUnitDone,
    renderFacultyDashboard,
    renderStudentView,
    renderStudentMentoringNotes,
    MentoringNoteQuickAdd,
    renderStudentDashboard,
    GenieHeaderButton,
    renderPersonalization,
    renderPersonalizationPersona,
    renderSessionTracker,
    GenieXapiEventsReporter,
    FeedbackStudentFilter,
    EnglishAssessment,
    renderEnglishAssessment,
};
